import { mediaQueryBreakpoints } from '../../Utils/Utils.js';

import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

const LatestNews = (domEl) => {

	const swiperEl = domEl.querySelector('.swiper');
	if(!swiperEl) {
		return;
	}

	new Swiper(swiperEl, {
		modules: [Navigation],
		loop: false,
		autoplay: false,
		speed: 400,
		navigation: {
			nextEl: swiperEl.querySelector('.swiper-button-next'),
			prevEl: swiperEl.querySelector('.swiper-button-prev'),
		},
		spaceBetween: 20,
		slidesPerView: 1.2,
		breakpoints: {
			[mediaQueryBreakpoints.sm]: {
				slidesPerView: 3,
			},
			[mediaQueryBreakpoints.md]: {
				slidesPerView: 4,
			}
		}
	});
};

export default LatestNews;